import { Grid } from "@material-ui/core";
import {FormDialog} from "../../../controls";
import AircraftDefectsEditor from "./AircraftDefectsEditor";


const AircraftDefectsDialog = (props) => {
  const SystemData = props.SystemData;
  const eventBus = SystemData.eventBus;
  const classes = props.classes

  const handleAddDefect = () => {
    if (eventBus) {
      eventBus.trigger('Defects.AddDefect');
    }
  }

  return (
    <FormDialog
      title={props.title}
      message=""
      open={props.open}
      record={props.record}
      dialogOptions={{width: "lg", maxWidth: "lg"}}
      classes={classes}
      //validator={Validator}
      buttons = {{
        addDefect: {icon: "add_circle", key: "Add Deferred Defect", label: "Add Deferred Defect", color: "primary"},
        //save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
        cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
      }}
      onChange={(state) => {
        if (state.buttonPressed === "save") {
          props.onChange();
        } else if (state.buttonPressed === "addDefect") {
          handleAddDefect();
        } else {
          props.onChange();
        }
      }}

    >
      <Grid container checkChildren={true} spacing={3}>
        <Grid item xs={12} checkChildren={true}>
          {(record, changeRecord) => (
            <AircraftDefectsEditor
              aircraftUuid={props.aircraftUuid}
              aircraftTailNumber={props.aircraftTailNumber}
              classes={props.classes}
            />
          )}
        </Grid>
      </Grid>
    </FormDialog>
  )

}

export default AircraftDefectsDialog;
